import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Common } from "../../utils/common";

const $ = window.$;

function ActiveCampaignsTable({ tableData }) {
  const [isOpen, setIsOpen] = useState(true);

  const tableEl = useRef();

  useEffect(() => {
    const $el = $(tableEl.current);
    const table = $el.DataTable({
      data: tableData,
      dom: "<fB>tlip",
      lengthMenu: [
        [10, 25, 50, 100, 200, -1],
        [10, 25, 50, 100, 200, "All"],
      ],
      columnDefs: [{ className: "text-center", targets: "_all" }],
      stateSave: true,
      stateSaveCallback: function (oSettings, oData) {
        localStorage.setItem("DataTables-AI-Active-Campaigns", JSON.stringify(oData));
      },
      stateLoadCallback: function (oSettings) {
        return JSON.parse(localStorage.getItem("DataTables-AI-Active-Campaigns"));
      },
      buttons: [
        { extend: "colvis", text: "Select Columns", collectionLayout: "fixed two-column" },
        {
          extend: "excelHtml5",
          text: "Data Export",
          title: "online_chat_campaigns",
          exportOptions: {
            columns: function (idx, data, node) {
              const hideFromExport = [];
              var isVisible = table.column(idx).visible();
              var isNotForExport = $.inArray(idx, hideFromExport) !== -1;
              return isVisible && !isNotForExport ? true : false;
            },
          },
        },
      ],
      columns: columnBuilder(),
      responsive: true,
      destroy: true,
      footerCallback: function () {
        const api = this.api();

        const totalRows = api.rows().count();

        const totalChats = api
          .column(3)
          .data()
          .reduce((a, b) => a + b, 0);

        $(api.column(2).footer()).html(Common.formatNumberWithCommas(totalRows));
        $(api.column(3).footer()).html(Common.formatNumberWithCommas(totalChats));
      },
    });

    return () => {
      // Destroys DataTable instance whenever component unmounts
      table.destroy();
    };
  }, [tableData]);

  return (
    <>
      <div
        className="active_campaigns_table_header"
        role="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className={isOpen ? "fa fa-caret-down" : "fa fa-caret-right"} /> Online Chat Campaigns
      </div>
      <div hidden={!isOpen} className="table-responsive" style={{ paddingBottom: "30px" }}>
        <table
          ref={tableEl}
          className="table table-hover table-striped vertical_centered table-bordered"
          style={{ width: "100%" }}
        >
          <thead>
            <tr>
              <th>Location Name</th>
              <th>Domain Name</th>
              <th>Campaign Name</th>
              <th>Chat Count</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Total:
              </th>
              <th style={{ textAlign: "center" }}></th>
              <th></th>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
}

function columnBuilder() {
  const columns = [];
  columns.push({ data: "location_name", className: " " });
  columns.push({ data: "domain_name", visible: false });
  columns.push({ data: "campaign_name", className: " " });
  columns.push({ data: "number_of_chat_conversations", render: $.fn.dataTable.render.number(",") });
  return columns;
}

ActiveCampaignsTable.propTypes = {
  tableData: PropTypes.array.isRequired,
};

export default ActiveCampaignsTable;
